class Controller {
  constructor() {
    "ngInject";
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/dispInfo/dispInfo.controller.js